import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FontAwesome from 'react-fontawesome';
import './tableGridAnomaly.css';
import {Button } from "reactstrap";
import {labels} from "../../util/constants";

let propsG = [];

const cellEditProp = {
    mode: 'click'
};

const options = {
    sortName: ['anomaly_name_pt'], //TODO VERIFICAR IDIOMA
    sortOrder: ['asc'],
};

const getButton = (cell,row)=>{
    return (
        <div>
            <Button title={labels.editAnomaly} color="link" className={'btn-edit'} onClick={()=>{propsG.editAnomaly(row)}}><FontAwesome name={'edit'}/></Button>
            <Button title={labels.removeAnomaly} color="link" className={'btn-cancel'} onClick={()=>{propsG.removeAnomaly(row)}}><FontAwesome name={'times-circle'}/></Button>
        </div>);
};

export const TableGridAnomaly = (props) => {
    propsG = props;
    return(
        <div className="div-margin-top col-15">
                <BootstrapTable width data={props.data} options={options} cellEdit={ cellEditProp }  multiColumnSort={1} striped hover
                                condensed pagination >
                    <TableHeaderColumn dataField="anomaly_name_pt" width='80%' editable={false} isKey
                                       dataAlign='left' dataSort> {labels.anomaly} </TableHeaderColumn>
                    <TableHeaderColumn  dataField="actions"  editable={false} dataFormat={getButton}
                                        dataAlign='center'> {labels.action} </TableHeaderColumn>

                </BootstrapTable>

        </div>

    );
};


// WEBPACK FOOTER //
// ./src/components/TableGridAnomaly/tableGridAnomaly.js